///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.matches = abcsetup.new_customer_matching.events.matches || {};
abcsetup.new_customer_matching.events.matches.index = abcsetup.new_customer_matching.events.matches.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.matches.index = {
    saveTimer: null,

    init: function () {

        const _this = this;

        // If the table has rows, enable the decline all button
        // Search the table to see if wac and/or accept buttons are present
        $("#app_data_tables_new_customer_matching_item_match_data_table").on('draw.dt', function () {
            $('#decline-all').prop('disabled', ($(this).data('total-records') < 1));

            if ($(this).find('button[name="form_action"][value="wac"]').length > 0) {
                $('.batch-action[value="wac"]').show();
            } else {
                $('.batch-action[value="wac"]').hide();
            }

            if ($(this).find('button[name="form_action"][value="accept"]').length > 0) {
                $('.batch-action[value="accept"]').show();
            } else {
                $('.batch-action[value="accept"]').hide();
            }
        });

        $(document).on("click", ".batch-action:not(.decline-action)", function() {
            const action = $(this).val();
            let phrase = action;
            let message = '';

            if (action == "approve" || action == "approve_internal") {
                phrase = $(this).text().toLowerCase() + " for";
            } else if (action == "wac"){
                phrase = "submit bid(s) at wac for";
                message += "<p>The chances are low winning the business at WAC.</p>";
            }

            abcsetup.alerts.confirm('Batch Action Confirmation', "Are you sure you want to " + phrase + " the selected item(s)?"+message, function(resp){
                if (!resp){
                    return;
                }

                let valid = true;

                // First loop through to validate all fields
                $('input.batch:checked').each(function(i, e){
                    const $parentRow = $(e).closest('tr');
                    let action_enabled = ($parentRow.find('button[name="form_action"][value="'+action+'"]').not(':disabled').not('.d-none').length > 0);

                    if (action_enabled) {
                        if (!_this.validate($parentRow, action)) {
                            valid = false;
                            return false;
                        }
                    } else {
                        if (action == 'approve' && $parentRow.find('button[name="form_action"][value="approve_to_sa"]').not(':disabled').not('.d-none').length > 0) {
                            if (!_this.validate($parentRow, 'approve_to_sa')) {
                                valid = false;
                                return false;
                            }
                        } else if (action == 'accept' && $parentRow.find('button[name="form_action"][value="accept_to_sa"]').not(':disabled').not('.d-none').length > 0) {
                            if (!_this.validate($parentRow, 'accept_to_sa')) {
                                valid = false;
                                return false;
                            }
                        }
                    }
                });

                // Second loop through to take action on eligible rows
                if (valid) {
                    $('input.batch:checked').each(function(i, e){
                        const $parentRow = $(e).closest('tr');
                        let  action_enabled = ($parentRow.find('button[name="form_action"][value="'+action+'"]').not(':disabled').not('.d-none').length > 0);
                        if (action_enabled){
                            abcsetup.blockUI(true); // Resets each time
                            _this.takeAction($(e).val(), action);
                        } else if (action == 'approve' && $parentRow.find('button[name="form_action"][value="approve_to_sa"]').not(':disabled').not('.d-none').length > 0) {
                            abcsetup.blockUI(true); // Resets each time
                            _this.takeAction($(e).val(), 'approve_to_sa');
                        } else if (action == 'accept' && $parentRow.find('button[name="form_action"][value="accept_to_sa"]').not(':disabled').not('.d-none').length > 0) {
                            abcsetup.blockUI(true); // Resets each time
                            _this.takeAction($(e).val(), 'accept_to_sa');
                        } else if (action == 'decline' && $parentRow.find('button[name="form_action"][value="decline"]').not(':disabled').length > 0) {
                            abcsetup.blockUI(true); // Resets each time
                            _this.takeAction($(e).val(), 'decline');
                    } else {
                            return false;
                        }
                    });

                    $('#bulk-actions .batch-action').not('.d-none').prop('disabled', true);
                }
            });
        });

        $(document).on("change", "input.batch", function(){
            $('#bulk-actions .batch-action').not('.d-none').prop('disabled', true);

            $('input.batch:checked').each(function(i, e){
                const $parentRow = $(this).closest('tr');
                const row_form_actions = $parentRow.find('button[name="form_action"]').not(':disabled').not('.d-none');
                row_form_actions.each(function(i, e){
                    $('#bulk-actions .batch-action[value="'+$(this).val()+'"]').prop('disabled', false);

                    if ($(this).val() == 'approve_to_sa') {
                        $('#bulk-actions .batch-action[value="approve"]').prop('disabled', false);
                    }

                    if ($(this).val() == 'accept_to_sa') {
                        $('#bulk-actions .batch-action[value="accept"]').prop('disabled', false);
                    }
                });

                $('#bulk-actions .batch-action.decline-action').prop('disabled', false);
            });
        });

        $(document).on("change", "#batch-all", function(){
            $('input.batch').not(':disabled').prop('checked', ($(this).is(':checked'))).trigger('change');
        });

        $(document).on("paste keyup change", 'input.putable', function(event) {
            if (this.saveTimer) {
                clearTimeout(this.saveTimer);
            }

            var $this = $(this);

            this.saveTimer = setTimeout(function() {
                $this.removeClass('error-border');

                // Validate when the field changes before saving
                if (!abcsetup.new_customer_matching.events.matches.index.validate($this.closest('tr'), 'field_change')) {
                    $this.addClass('error-border');
                    return;
                }

                let btn = $this.closest('tr').find('button[name="form_action"][value="approve"]');
                let sap_num = $this.closest('tr').find('input.sap_num');
                let counter_btn = $this.closest('tr').find('button[name="form_action"][value="counter"]');
                let accept_btn = $this.closest('tr').find('button[name="form_action"][value="accept"]');

                if (!btn[0]) {
                    btn = $this.closest('tr').find('button[name="form_action"][value="approve_to_sa"]');
                }
                
                if (!accept_btn[0]) {
                    accept_btn = $this.closest('tr').find('button[name="form_action"][value="accept_to_sa"]');
                }

                // Disable WAC button for current_bid field
                if ($this.attr('name') == 'current_bid') {
                    btn = $this.closest('tr').find('.btn-wac');

                    if (accept_btn[0]) {
                        accept_btn.prop('disabled', ($this.data('original-value') != $this.val()));
                    }
                }

                // Disable button if offer price has a value
                btn.prop('disabled', $this.val() !== '');
                counter_btn.prop('disabled', $this.val() === '');

                if (sap_num[0]) {
                    abcsetup.new_customer_matching.events.matches.index.saveField($this);
                } else {
                    counter_btn.prop('disabled', true);
                }

                $this.closest('tr').find('input.batch').trigger('change');
            }, 1250);
        });

        $(document).on("click", "form.workflow-form button[name='form_action']", function(event) {
            const button = $(this);
            let action = button.val();
            let message = "";
            var $parentRow = button.closest('tr');
            var button_label =  $(this).text().toLowerCase();

            if(!abcsetup.new_customer_matching.events.matches.index.validate($parentRow, action)){
                return;
            }

            var previousBid = $parentRow.find('.previous-bid').val();
            var previousUserBid = $parentRow.find('.previous-user-bid').val();
            var amount = 0;

            if (action == "wac") {
                amount = $parentRow.find('input[name=wac]').val();
                message += "<p>The chances are low winning the business at WAC.</p>";
            } else if (action == "counter" || action == "accept" || action == "accept_to_sa") {
                amount = $parentRow.find('input[name=target_price]').val();
            } else if (action == "approve" || action == "approve_to_sa") {
                if (button_label === 'submit' || $parentRow.find('input[name=current_bid]').prop('readonly')) {
                    amount = $parentRow.find('input[name=current_bid]').val();
                } else {
                    amount = $parentRow.find('input[name=target_price]').val();
                }
            }

            // Adjust phrase based on action
            var phrase = (action == "wac") ? "submit bid at wac for" : action;

            if (action == 'approve' || action == 'approve_to_sa' || action == 'approve_internal') {
                phrase = button_label;
            }

            var acceptPhrase = (action == 'accept' || action == 'accept_to_sa') ? "Accept Counter Offer" : "Bid Amount";

            if (previousUserBid) {
                message += "SAP: <b>" + $parentRow.find('.sap_num').val() + "</b><br>Description: <b>" + $parentRow.find('.description').val() + "</b><br>Previous Bid: <b>$" + previousUserBid + "</b><br>" + acceptPhrase + ": <b>$" + amount + "</b>";
            } else {
                message += "SAP: <b>" + $parentRow.find('.sap_num').val() + "</b><br>Description: <b>" + $parentRow.find('.description').val() + "</b><br>" + acceptPhrase + ": <b>$" + amount + "</b>";
            }

            if (action == "reject" || action == 'decline') {
                message = "This will remove the item from the queue.";
            }

            let title = "Are you sure you want to " + phrase + " this item?";

            if (abcsetup.userRole.class === 'private_label_team' && (action === 'approve' || action == 'approve_internal')) {
                title = 'Confirm';
                message = 'Are you sure you want to approve this item?';
            }

            abcsetup.alerts.confirm(title, message, function(resp) {
                if (resp) {
                    $parentRow.find('.form_action').val(action);
                    $parentRow.find('form').submit();
                }
            });
        });

        // Consolidate all rejections into one modal
        $('#reject-modal').on('show.bs.modal', function (event) {
            const id = $(event.relatedTarget).data('id');
            const type = $(event.relatedTarget).data('type');

            let body = 'Are you willing to bid at WAC and supply the requested quantity, or can you not support the requested quantity even at WAC?';
            let title = 'Decline Item';

            if (type === 'event'){
                body = 'Are you willing to bid at WAC and supply the requested quantities, or can you not support the requested quantities even at WAC?';
                title = 'Decline All Items';
            }

            $('#reject-modal-title').html(title);
            $('#reject-modal-body').html(body);
            $('#wac-bid-btn').data({'id': id, 'type': type});
            $('#cannot-supply-btn').off('click').on('click', function() {
                abcsetup.blockUI(true);
                $('#reject-modal').modal('hide');

                if (type === 'event') {
                    axios.post('/api/new_customer_matching/events/'+id+'/reject_all').then(function (response) {
                        location.reload();
                    });
                } else if (type === 'item-match') {
                    axios.post('/api/new_customer_matching/matches/' + id + '/actions/decline', null, {
                        params: {
                            reject_reason: 'cannot_supply_requested_quantity',
                            reject_reason_text: 'Cannot supply the requested quantity'
                        }
                    }).then(function (response) {
                        window.LaravelDataTables["app_data_tables_new_customer_matching_item_match_data_table"].ajax.reload();
                    });
                } else if (type === 'item-batch') {
                    $('button.batch-action[value="decline"]').trigger('click');
                }
            });

            $('#reject-modal-wac-btn').off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $('#reject-modal').modal('hide');
                if (type === 'item-match') {
                    $('input.batch[value='+id+']')
                        .parents('tr')
                        .find('button.btn-wac-hidden')
                        .trigger('click');
                } else if (type === 'item-batch') {
                    $('button.batch-action[value=wac]').trigger('click');
                }
            });
        });

        $(document).on("click", '#wac-bid-btn', function(event) {
            const id = $(this).data('id');
            const type = $(this).data('type');

            if (type === 'event') {
                abcsetup.blockUI(true);
                axios.post('/api/new_customer_matching/events/'+id+'/bid_wac').then(function (response) {
                    location.reload();
                });
            } else if (type === 'item-match') {
                $('#submit-wac-modal').modal('hide');
                $('input.batch[value='+id+']').parents('tr').find('button.btn-wac').trigger('click');
            } else if (type === 'item-batch') {
                $('button.batch-action[value=wac]').trigger('click');
            }
        });

        // Fix for history modal not always showing
        $(document).on("click", '.bid-history-btn', function(event) {
            const modal = $('#' + $(this).data('id')).clone();
            $('#' + $(this).data('id')).remove();
            modal.appendTo('body').modal('show');
        });

        abcsetup.new_customer_matching.events.matches_datatable.init();
        abcsetup.new_customer_matching.events.matches.non_carried_items.init();
        abcsetup.new_customer_matching.events.common.ItemMatchDataTable.init();
    },

    saveField(field) {
        var matchId = field.data('match-id');
        var value = field.val();
        var name = field.attr('name');
        var values = {};
        values[name] = value;

        axios.put('/api/new_customer_matching/matches/' + matchId, values).then(function (response) {
            field.removeClass('success-border error-border');

            if (response.data.success) {
                field.addClass('success-border');
            } else {
                toastr.error("Oh no! Something went wrong while updating.");
                field.addClass('error-border');
            }
        });
    },

    validate($parentRow, action) {

        // Stop the screen from piling up error messages if coming from field change
        if (action == 'field_change' && $('#toast-container')[0]) {
            return false;
        }

        // Clear errors
        $parentRow.find('input.error-border').removeClass('error-border success-border');

        let match_id =  $parentRow.find('.match-id').val();
        let wac = parseFloat($parentRow.find('.wac').val());
        let previous_bid =  $parentRow.find('.previous-bid').val();
        let previous_user_bid = parseFloat($parentRow.find('.previous-user-bid').val());
        let $current_bid = $('#current_bid_' + match_id);
        let current_bid = parseFloat($current_bid?.val() || 0);
        let $target_price = $('#target_price_' + match_id);
        let target_price = parseFloat($target_price?.val() || 0);
        let error = '';
        let $field = '';

        // Only CMs and SAs can counter which is updating the target_price field
        if (action == 'counter') {
            $field = $target_price;
            if (target_price == 0) {
                error = "Please enter a counter offer.";
            } else if (target_price >= wac) {
                error = "Counter offer must be less than WAC.";
            } else if (previous_user_bid > 0 && target_price == previous_user_bid) {
                error = "Counter offer must not equal your last bid of " + new Intl.NumberFormat('en-US', { 'style':'currency', 'currency':'USD' }).format(previous_user_bid);
            }

        // Approvals can happen from all roles
        } else if ($current_bid[0] && (action == 'approve' || action == 'approve_to_sa' || action == 'field_change')) {
            $field = $current_bid;
            if (current_bid == 0 && action !== 'field_change') {
                error = "Please enter a bid offer.";
            } else if (current_bid > wac) {
                error = "Bid must be less than or equal to the wac price.";
            } else if (abcsetup.userRole.class == 'vendor' && target_price !== 0 && (previous_user_bid !== 0 && current_bid >= previous_user_bid)) {
                error = "The Offer Price must be less than your last bid of " + new Intl.NumberFormat('en-US', { 'style':'currency', 'currency':'USD' }).format(previous_user_bid);
            }
           
        // Acceptance limited to vendors
        } else if (action =="accept" || action == "accept_to_sa") {
            $field = $target_price;
            if (target_price == 0) {
                error = 'Counter bid must be set.';
            }
        }

        if (error !== '') {
            $field.addClass('error-border');
            toastr.error(error);
            return false;
        } else {
            return true;
        }
    },

    takeAction: function (matchId, action) {
        abcsetup.blockUI(true);
        axios.post('/api/new_customer_matching/matches/' + matchId + '/actions/' + action).then(function (response) {
            abcsetup.alerts.flashMessage(response.data.message);
            window.LaravelDataTables["app_data_tables_new_customer_matching_item_match_data_table"].ajax.reload();
        });

        $('#batch-all').prop('checked', false);
    },

}